import React from 'react';
import HealthInsurerListTable from './HealthInsurerListTable';
import { connect } from 'react-redux';
import Card from 'react-bootstrap/Card';
import { healthInsurerListFetch, healthInsurerListSetPage } from '../../lib/redux/actions/healthInsurer';
import Alert from 'react-bootstrap/Alert';
import Paginator from '../../components/common/Paginator';
import * as ROUTES from '../../lib/routing/frontend';
import MASpinner from '../../components/common/MASpinner';

const mapStateToProps = (state) => ({
  ...state.healthInsurer,
});

const mapDispatchToProps = {
  healthInsurerListFetch,
  healthInsurerListSetPage,
};

class HealthInsurerListContainer extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      filterText: '',
    };
  }

  getCombinedFilters() {
    const { filters, defaultFilters = {} } = this.props;
    return { ...filters, ...defaultFilters, pagination: false };
  }

  componentDidMount() {
    this.props.healthInsurerListFetch(this.getQueryParamPage(), this.getCombinedFilters());
  }

  componentDidUpdate(prevProps) {
    const { currentPage, healthInsurerListFetch, healthInsurerListSetPage, filters } = this.props;

    if (prevProps.match.params.page !== this.getQueryParamPage()) {
      healthInsurerListSetPage(this.getQueryParamPage());
    }
    if (prevProps.currentPage !== currentPage || prevProps.filters !== filters) {
      healthInsurerListFetch(currentPage, this.getCombinedFilters());
    }
  }

  getQueryParamPage() {
    return Number(this.props.match.params.page) || 1;
  }

  changePage(page) {
    const { history, healthInsurerListSetPage } = this.props;
    healthInsurerListSetPage(page);
    history.push(ROUTES.HEALTH_INSURERS.ALL.replace(':page', page));
  }

  nextPage() {
    const { currentPage, pageCount } = this.props;
    const newPage = Math.min(currentPage + 1, pageCount);
    this.changePage(newPage);
  }

  prevPage() {
    const { currentPage } = this.props;
    const newPage = Math.max(currentPage - 1, 1);
    this.changePage(newPage);
  }

  render() {
    const { healthInsurers: allHealthInsurers, isFetchingHealthInsurers, currentPage, pageCount, pageTitle } = this.props;

    let healthInsurers = allHealthInsurers.filter((hi) => {
      return hi.name.toLowerCase().includes(this.state.filterText);
    });

    return (
      <div>
        <Card>
          <Card.Header>
            <div className="d-flex justify-content-between align-items-center">
              <div>{pageTitle}</div>
              <div className="d-flex justify-content-between align-items-center">
                <div className="position-relative mr-2">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Search by name"
                    value={this.state.filterText}
                    onChange={(e) => this.setState({ filterText: e.target.value.toLowerCase() })}
                  />
                  {this.state.filterText && (
                    <button
                      type="button"
                      className="btn btn-link"
                      onClick={() => this.setState({ filterText: '' })}
                      style={{
                        position: 'absolute',
                        right: '0',
                        top: '0',
                        bottom: '0',
                        border: 'none',
                        background: 'none',
                        padding: '0 10px',
                      }}>
                      <i className="fa fa-times" />
                    </button>
                  )}
                </div>
                {!isFetchingHealthInsurers && healthInsurers && healthInsurers.length > 0 && (
                  <span className="ml-2 tabular-data-result-count">{healthInsurers.length} health insurers</span>
                )}
              </div>
            </div>
          </Card.Header>

          {isFetchingHealthInsurers && (
            <Card.Body>
              <MASpinner />
            </Card.Body>
          )}

          {!isFetchingHealthInsurers && (healthInsurers === null || healthInsurers.length === 0) && (
            <Card.Body>
              <Alert variant={'info'} className="mb-0">
                <i className="fas fa-info-circle" /> No health insurers found
              </Alert>
            </Card.Body>
          )}

          {!isFetchingHealthInsurers && healthInsurers && healthInsurers.length > 0 && <HealthInsurerListTable healthInsurers={healthInsurers} />}

          {!isFetchingHealthInsurers && healthInsurers && healthInsurers.length > 0 && (
            <Paginator
              currentPage={currentPage}
              pageCount={pageCount}
              setPage={this.changePage.bind(this)}
              nextPage={this.nextPage.bind(this)}
              prevPage={this.prevPage.bind(this)}
            />
          )}
        </Card>
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(HealthInsurerListContainer);
